import i18n from '@/lang/i18n'

class RegistryRequestGridContextMenu {
    getRequestedItems(params, actions) {
        let gridData = params?.node.data
        return [
            {
                name: i18n.t('registry.requestGrid.contextMenu.processRequest'),
                action: actions.processRequest.action,
                cssClasses: !actions.processRequest.enabled(gridData) ? ['not-show'] : ''
            },
            {
                name: i18n.t('registry.requestGrid.contextMenu.cancelRequest'),
                action: actions.cancelRequest.action,
                cssClasses: !actions.cancelRequest.enabled(gridData) ? ['not-show'] : ''
            },
            {
                name: i18n.t('registry.requestGrid.contextMenu.registerIncident'),
                action: actions.createIncident.action,
                cssClasses: !actions.createIncident.enabled(gridData) ? ['not-show'] : ''
            /* ,
        subMenu: [
          {
            name: i18n.t('global.patient')
          },
          {
            name: i18n.tc('global.request', 1)
          },
          {
            name: i18n.t('registry.requestGrid.contextMenu.case'),
            cssClasses: gridData.status.id !== 1 ? ['not-show'] : ''
          },
          {
            name: i18n.tc('global.sample', 1)
          }
        ] */
            },
            {
                name: i18n.t('hoverBtn.editCase'),
                action: actions.editCase.action,
                cssClasses: !actions.editCase.enabled(gridData) ? ['not-show'] : ''
            },
            {
                name: i18n.t('registry.requestGrid.contextMenu.viewIncidence'),
                action: actions.viewIncident.action,
                cssClasses: !actions.viewIncident.enabled(gridData) ? ['not-show'] : ''
            },
            {
                name: i18n.t('registry.requestGrid.contextMenu.viewRequest'),
                action: actions.viewRequest.action,
                cssClasses: !actions.viewRequest.enabled(gridData) ? ['not-show'] : ''
            },
            {
                name: i18n.t('registry.requestGrid.contextMenu.printRequest'),
                action: actions.printRequest.action,
                cssClasses: !actions.printRequest.enabled(gridData) ? ['not-show'] : ''
            },
            {
                name: i18n.t('registry.requestGrid.contextMenu.printTag'),
                action: actions.printTag.action,
                cssClasses: !actions.printTag.enabled(gridData) ? ['not-show'] : ''
            },
            {
                name: i18n.t('registry.requestGrid.contextMenu.printReturnedReport'),
                action: actions.printReturnedReport.action,
                cssClasses: !actions.printReturnedReport.enabled(gridData) ? ['not-show'] : ''
            },
            {
                name: i18n.t('registry.requestGrid.contextMenu.printPathologyReport'),
                action: actions.printPathologyReport.action,
                cssClasses: !actions.printPathologyReport.enabled(gridData) ? ['not-show'] : ''
            },
            {
                name: i18n.t('hoverBtn.return'),
                action: actions.returnRequest.action,
                cssClasses: !actions.returnRequest.enabled(gridData) ? ['not-show'] : ''
            },
            {
                name: i18n.t('hoverBtn.returnPrint'),
                action: actions.returnAndPrint.action,
                cssClasses: !actions.returnAndPrint.enabled(gridData) ? ['not-show'] : ''
            },
            {
                name: i18n.tc('global.showInGlobalLocator'),
                action: actions.showInGlobalLocator.action,
                cssClasses: !actions.showInGlobalLocator.enabled(gridData) ? ['not-show'] : ''
            }
        ]
    }
}

export default new RegistryRequestGridContextMenu()
